export const acquiredV5Ashn = {
  inHouse: "Acquired After Admission",
  externally: "Present on Admission",
  IHA: "IHA",
  POA: "PoA",
  PIHAw: "PIHA-w",
  IHAw: "IHA-w",
  unknown: "Not Set"
};
